export default __webpack_public_path__ + "static/media/Notification.b4f8f760.svg";